export default __webpack_public_path__ + "static/media/Meals4MeSocial.00e6d202.png";